import House3 from "../../assets/homepage/House3.jpeg";
import House2 from "../../assets/homepage/House2.jpeg";
import House8 from "../../assets/homepage/House8.jpeg";
import { BsWhatsapp } from "react-icons/bs";
import { Link } from "react-router-dom";

const stats = [
  { value: "10+", label: "Years of Excellence" },
  { value: "2013", label: "Founded" },
  { value: "500+", label: "Plans Designed" },
  { value: "100%", label: "Client Commitment" },
];

const values = [
  {
    icon: "🏛️",
    title: "Blended Architecture",
    desc: "We fuse African and Western architectural traditions into homes that feel both rooted and contemporary.",
  },
  {
    icon: "🔨",
    title: "Premium Craftsmanship",
    desc: "Every detail is considered. We source only the highest-grade local materials and partner with the region's best vendors.",
  },
  {
    icon: "👥",
    title: "Expert In-House Team",
    desc: "Plan managers, builder representatives, and designers collaborate under one roof to serve you seamlessly.",
  },
  {
    icon: "🌍",
    title: "Built for Generations",
    desc: "Our homes are engineered to last — structurally sound, timeless in design, and tailored to the African lifestyle.",
  },
];

const AboutUs = () => {
  return (
    <div className="font-Montserrat min-h-screen">

      {/* ── Hero ── */}
      <div className="relative mt-[56px] md:mt-[72px] h-[60vh] md:h-[75vh] overflow-hidden">
        <img
          src={House3}
          alt="Perfect Shelters luxury home"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70" />
        <div className="absolute inset-0 flex flex-col items-center justify-center text-white text-center px-4">
          <p className="text-[#1877F2] uppercase tracking-[0.3em] text-sm md:text-base font-semibold mb-3">
            Our Story
          </p>
          <h1 className="text-4xl md:text-7xl font-bold leading-tight">
            Who We Are
          </h1>
          <p className="mt-4 text-base md:text-xl text-white/80 max-w-xl leading-relaxed">
            Building luxury homes across Nigeria since 2013.
          </p>
        </div>
      </div>

      {/* ── Stats bar ── */}
      <div className="bg-[#1877F2]">
        <div className="max-w-5xl mx-auto grid grid-cols-2 md:grid-cols-4 divide-x divide-white/30">
          {stats.map(({ value, label }) => (
            <div key={label} className="py-8 px-4 text-center text-white">
              <p className="text-3xl md:text-4xl font-bold">{value}</p>
              <p className="text-xs md:text-sm mt-1 uppercase tracking-wide opacity-90">{label}</p>
            </div>
          ))}
        </div>
      </div>

      {/* ── Our Story ── */}
      <section className="max-w-6xl mx-auto px-4 md:px-10 py-16 md:py-24">
        <div className="flex flex-col md:flex-row gap-12 items-center">
          <div className="md:w-1/2 w-full">
            <div className="relative">
              <img
                src={House2}
                alt="Perfect Shelters construction project"
                className="w-full h-[340px] md:h-[460px] object-cover rounded-xl shadow-xl"
              />
              <div className="absolute -bottom-5 -right-5 w-28 h-28 bg-[#1877F2] rounded-xl -z-10 hidden md:block" />
            </div>
          </div>
          <div className="md:w-1/2 w-full space-y-5 text-gray-700 text-base md:text-lg leading-relaxed">
            <p className="text-[#1877F2] uppercase tracking-widest text-sm font-semibold">
              About Perfect Shelters
            </p>
            <h2 className="text-2xl md:text-4xl font-bold text-gray-900 leading-snug">
              Crafting homes that stand the test of time
            </h2>
            <p>
              Since 2013, Perfect Shelters has built luxury homes in different
              parts of Nigeria. We offer homeowners the perfect blend of African
              and Western architecture, multi-generational floor plans, and
              breathtaking living spaces.
            </p>
            <p>
              We take pride in the homes we build — combining the latest design
              trends with over 10 years of building experience. Our in-house
              team of expert plan managers, builder representatives, and
              designers work together to offer you a multitude of design options
              and floor plans tailored to the African lifestyle.
            </p>
            <p>
              Perfect Shelters seeks out the highest grade of local products and
              uses the region's best vendors and subcontractors to build a home
              that will last for generations.
            </p>
          </div>
        </div>
      </section>

      {/* ── Mission & Vision ── */}
      <section className="bg-gray-50 py-16 md:py-24">
        <div className="max-w-6xl mx-auto px-4 md:px-10">
          <div className="text-center mb-12">
            <p className="text-[#1877F2] uppercase tracking-widest text-sm font-semibold mb-2">
              What drives us
            </p>
            <h2 className="text-2xl md:text-4xl font-bold text-gray-900">
              Our Mission &amp; Vision
            </h2>
          </div>
          <div className="grid md:grid-cols-2 gap-8">
            {/* Mission */}
            <div className="bg-white rounded-2xl shadow-md overflow-hidden group hover:shadow-xl transition-shadow duration-300">
              <div className="h-2 bg-[#1877F2]" />
              <div className="p-8">
                <div className="w-14 h-14 bg-[#FFF8EC] rounded-full flex items-center justify-center mb-5">
                  <span className="text-2xl">🎯</span>
                </div>
                <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">
                  Our Mission
                </h3>
                <p className="text-gray-600 text-base md:text-lg leading-relaxed">
                  To create exceptional luxury homes that blend African and
                  Western architecture, exceeding homeowners' expectations
                  with impeccable craftsmanship and customer satisfaction.
                </p>
              </div>
            </div>
            {/* Vision */}
            <div className="bg-[#1877F2] rounded-2xl shadow-md overflow-hidden group hover:shadow-xl transition-shadow duration-300">
              <div className="h-2 bg-white/40" />
              <div className="p-8">
                <div className="w-14 h-14 bg-white/20 rounded-full flex items-center justify-center mb-5">
                  <span className="text-2xl">🔭</span>
                </div>
                <h3 className="text-xl md:text-2xl font-bold text-white mb-4">
                  Our Vision
                </h3>
                <p className="text-white/90 text-base md:text-lg leading-relaxed">
                  To be the leading provider of luxury homes in Nigeria —
                  setting the standard for quality, design, and client
                  experience across the continent.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── Why Choose Us ── */}
      <section className="max-w-6xl mx-auto px-4 md:px-10 py-16 md:py-24">
        <div className="text-center mb-12">
          <p className="text-[#1877F2] uppercase tracking-widest text-sm font-semibold mb-2">
            Why us
          </p>
          <h2 className="text-2xl md:text-4xl font-bold text-gray-900">
            What Makes Us Different
          </h2>
        </div>
        <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-6">
          {values.map(({ icon, title, desc }) => (
            <div
              key={title}
              className="bg-white border border-gray-100 rounded-xl p-6 shadow-sm hover:shadow-md hover:-translate-y-1 transition-all duration-300 text-center"
            >
              <div className="text-4xl mb-4">{icon}</div>
              <h4 className="font-bold text-gray-900 text-base mb-2">{title}</h4>
              <p className="text-gray-500 text-sm leading-relaxed">{desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ── CTA Banner ── */}
      <section className="relative overflow-hidden">
        <img
          src={House8}
          alt="Modern Nigerian home"
          className="w-full h-[320px] md:h-[420px] object-cover"
        />
        <div className="absolute inset-0 bg-black/65 flex flex-col items-center justify-center text-center px-4">
          <h2 className="text-2xl md:text-5xl font-bold text-white mb-4 max-w-2xl leading-tight">
            Ready to build your dream home?
          </h2>
          <p className="text-white/80 text-base md:text-lg mb-8 max-w-xl">
            Explore our plans or reach out today — our team is ready to guide
            you from concept to completion.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4">
            <Link
              to="/featured-house-plans"
              className="bg-[#1877F2] hover:bg-[#0e5fc7] text-white font-semibold py-3 px-8 rounded-full transition-colors duration-200"
            >
              Browse Plans
            </Link>
            <a
              href="https://wa.me/+2349033020343"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white font-semibold py-3 px-8 rounded-full transition-colors duration-200"
            >
              <BsWhatsapp />
              Chat on WhatsApp
            </a>
          </div>
        </div>
      </section>

    </div>
  );
};

export default AboutUs;
